<template>
  <div class="col-12 mt-2 profile pt-2 px-0">
    <div class="col-12 d-flex justify-content-center align-items-center picture">
      <img height="150" v-if="user.picture" class="picture-photo" :src="`${ api_url }/users/${ user.picture }`">
      <img height="150" v-else-if="user.is_social && user.social_avatar" class="picture-photo" :src="user.social_avatar">
      <img height="150" v-else class="picture-photo p-2 bg-white" src="../../assets/img/mascote.png">
    </div>
    <div class="col-12 bg-white rounded quadroshadow mt-2 py-2 name text-center">
      <div class="col-12 mb-1">
        <a target="_blank" :href="`/perfil/${ user.id }/${ user.name }`" class="text-left text-dark mt-4 mb-0">{{ user.name }}</a>
      </div>

      <div class="col-12 mb-3">
        <a href="#" @click.prevent="showEditUser"><small><b>Editar meu Perfil</b></small></a>
      </div>
      <support />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Support from './../../components/Support/Item'

export default {
  components: {
    "support": Support
  },
  data () {
    return {
      item: undefined,
      api_url: process.env.VUE_APP_ROOT_BASE,
    }
  },
  computed: {
    ...mapGetters({
      user: "getCurrentUser"
    })
  },
  methods: {
    showEditUser: function () {
      $("#user-data-modal").modal('show')
    }
  }
}
</script>
<style lang="scss" scoped>
  .quadroshadow {
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  }

</style>
